// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3BzmP","title":"Header_title__1Q8xV","side":"Header_side__1LeDL"};